import { createTheme } from "@mui/material";

const theme = createTheme({
	components: {
		MuiSkeleton: {
			styleOverrides: {
				root: {
					transform: "unset",
				},
			},
		},
		MuiPopover: {
			styleOverrides: {
				paper: {
					boxShadow: "0 4px 10px rgba(0, 0, 0, 0.25)",
				},
			},
		},
		MuiMenuItem: {
			styleOverrides: {
				root: {
					paddingLeft: "15px",
					paddingRight: "15px",
				},
			},
		},
		MuiListItemButton: {
			styleOverrides: {
				root: {
					"& .MuiTouchRipple-child": {
						backgroundColor: "rgba(196, 196, 196) !important",
					},
				},
			},
		},
	},
});

export default theme;
